import {
    UPDATE_VISION_RADIUS,
} from '../actionTypes'


export const updateVisionRadius = payload => ({
    type: UPDATE_VISION_RADIUS,
    payload
});